import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import { drGradingRetinopathy, drOphthalmoscopy } from './formOptions'
import RadioButtonController, { CheckBoxLikeRadio } from '../../../../components/RadioButtonController/RadioButtonController'
import { GridAutoColumnForm2 } from '../../../../styles/customStyles/customStyles'
import { ParentContainerSection } from '../DiabeticForm'

const DRGrading = (props) => {
    const { control, errors } = props

    const drRetinopathyArr=[
        {label: "No apparent DR", label2: "No Abnormalities", options:drGradingRetinopathy },
        {label: "Mild Non-proliferative DR", label2: "Microaneurysms only", options:drGradingRetinopathy },
        {label: "Moderate Non-proliferative DR", label2: "Microaneurysms and other signs (dot and blot hemorrhages, hard exudates, cotton-wool spots), but less than severe non-proliferative DR", options:drGradingRetinopathy },
        {label: "Severe Non-proliferative DR", label2: "Moderate Non-proliferative DR plus any of the following", options:drGradingRetinopathy },
        {label: "Proliferative DR", label2: "Presence of one or more of the following", options:drGradingRetinopathy},
    ]

    const drOphthalmoscopyArr=[
        {label: "No Abnormalities", options:drOphthalmoscopy },
        {label: "Microaneurysms only", options:drOphthalmoscopy },
        {label: "Microaneurysms and other signs (dot and blot hemorrhages, hard exudates, cotton-wool spots), but less than severe non-proliferative DR", options:drOphthalmoscopy },
        {label: "Moderate Non-proliferative DR plus any of the following", options:drOphthalmoscopy },
        {label: "Presence of one or more of the following", options:drOphthalmoscopy},
    ]

  return (
    <>
    <ParentContainerSection  heading="Section G: DR Grading">
       <GridAutoColumnForm2 sx={{ mb:"1rem", gridTemplateColumns: "repeat(1, 1fr)"}}>
        <TableContainer component={Paper} sx={{maxWidth: "95%"}}>
      <Table sx={{ maxWidth: "100%", '& td, & th': { border: '0.5px solid lightgray', padding:"6px" } }} aria-label="visual acuity table">
        <TableHead>
          <TableRow>
            <TableCell align="center">L</TableCell>
            <TableCell align="center">R</TableCell>
            <TableCell align="center">Diabetic Retinopathy (DR)</TableCell>
            <TableCell align="center">Findings Observable on Dilated Ophthalmoscopy</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {drRetinopathyArr.map((drRow,index)=>(
            <TableRow key={index}>
           
                            <TableCell>
                            <CheckBoxLikeRadio 
                                name="dr_retinopathy_left"
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={[drGradingRetinopathy[index]]}
                                isMargin={false}
                                isDisabled={true}
                                />
                            </TableCell>
                            <TableCell align="center">
                            <CheckBoxLikeRadio 
                                name="dr_retinopathy_right"
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={[drGradingRetinopathy[index]]}
                                isMargin={false}
                                isDisabled={true}
                                />
                            </TableCell>
                            <TableCell align='center'>{drRow.label}</TableCell>
                            <TableCell align='center'>{drRow.label2}</TableCell>
            </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
    
    </GridAutoColumnForm2>
    </ParentContainerSection>
    </>
  )
}

export default DRGrading